import { c as _c } from "react/compiler-runtime";
import { Divider } from '@common/components';
import { PaymentButton } from '../../_components/PaymentButton';
import { PriceSummaryRows } from '../../_components/PriceSummaryRows';
import { DeliveryFeeTooltip } from './DeliveryFeeTooltip';
import type { DiscountItem } from './DiscountTooltip';
import { DiscountTooltip } from './DiscountTooltip';
interface CartSidebarProps {
  productAmount: number;
  deliveryFee: number;
  discountAmount: number;
  finalAmount: number;
  totalCount: number;
  discountItems?: DiscountItem[];
  paymentDisabled?: boolean;
  onOrder?: () => void;
}
export const CartSidebar = t0 => {
  const $ = _c(26);
  const {
    productAmount,
    deliveryFee,
    discountAmount,
    finalAmount,
    totalCount,
    discountItems,
    paymentDisabled,
    onOrder
  } = t0;
  const t1 = discountAmount > 0 && "-";
  let t2;
  if ($[0] !== discountAmount) {
    t2 = discountAmount.toLocaleString();
    $[0] = discountAmount;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <div className="flex h-44 items-center justify-center bg-Gray-black px-16 shadow-md"><span className="font-700 text-Gray-white typo-body4">예상 할인 금액 {t1}{t2}원</span></div>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DeliveryFeeTooltip />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== discountItems) {
    t5 = <DiscountTooltip items={discountItems} />;
    $[6] = discountItems;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== deliveryFee || $[9] !== discountAmount || $[10] !== finalAmount || $[11] !== productAmount || $[12] !== t5) {
    t6 = <PriceSummaryRows productAmount={productAmount} deliveryFee={deliveryFee} discountAmount={discountAmount} finalAmount={finalAmount} deliveryFeeTooltip={t4} discountTooltip={t5} />;
    $[8] = deliveryFee;
    $[9] = discountAmount;
    $[10] = finalAmount;
    $[11] = productAmount;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Divider />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== finalAmount || $[16] !== onOrder || $[17] !== paymentDisabled || $[18] !== totalCount) {
    t8 = <PaymentButton finalAmount={finalAmount} totalCount={totalCount} disabled={paymentDisabled} onClick={onOrder} />;
    $[15] = finalAmount;
    $[16] = onOrder;
    $[17] = paymentDisabled;
    $[18] = totalCount;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <div className="mt-12 border border-Gray-900"><div className="flex flex-col gap-36 px-32 py-40">{t6}{t7}{t8}</div></div>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t3 || $[24] !== t9) {
    t10 = <aside className="sticky top-20 order-2 self-start py-20 mobile-tablet:hidden">{t3}{t9}</aside>;
    $[23] = t3;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};